import cnpjMask from '@vr/devkit/masks/cnpjMask';
import { Types } from './actions';

export const INITIAL_STATE = {
  step: 1,
  showModal: false,
  tipo: '',
  cnpj: '',
  razaoSocial: '',
  telefone: '',
  nomeFantasia: '',
  endereco: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  cep: '',
  categoria: '',
  status: '',
  ecNovo: true,
  produtos: [],
  respostas: [],
};

export default function indicacao(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.UPDATE_FIELD: {
      const { field, value } = action.payload;
      const newState = { ...state };
      newState[field] = value;
      return newState;
    }
    case Types.UPDATE_RESPOSTA: {
      const { codigo, produtos, required } = action.payload;
      const [respostaOld] = state.respostas.filter(
        res => res.codigo === codigo,
      );
      let respostas;

      if (respostaOld) {
        respostas = [
          { codigo, produtos, required },
          ...state.respostas.filter(res => res.codigo !== codigo),
        ];
      } else {
        respostas = [{ codigo, produtos, required }, ...state.respostas];
      }
      return { ...state, respostas };
    }
    case Types.SEARCH_ENDERECO:
      return { ...state, ...action.payload };
    case Types.SEARCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        step: 1,
        cnpj: cnpjMask(String(payload.cnpjEC)),
        status: payload.statusEC,
        razaoSocial: payload.razaoSocial,
        telefone: payload.telefone,
        nomeFantasia: payload.nomeFantasia,
        endereco: payload.endereco,
        numero: payload.numero,
        complemento: payload.complemento,
        bairro: payload.bairro,
        cidade: payload.cidade,
        estado: payload.estado,
        cep: payload.cep,
        produtos: payload.produtosIndicacaoEC,
        categoria: '',
        ecNovo: false,
      };
    }
    case Types.SEARCH_FAILURE: {
      return {
        ...state,
        step: 1,
        status: '',
        razaoSocial: '',
        telefone: '',
        nomeFantasia: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        produtos: [],
        categoria: '',
        ecNovo: true,
      };
    }
    case Types.SEARCH_ENDERECO_FAILURE: {
      return {
        ...state,
        ecNovo: true,
        produtos: [],
      };
    }
    case Types.SET_TIPO_INDICACAO: {
      if (state.tipo !== action.payload) {
        return { ...INITIAL_STATE, tipo: action.payload };
      }
      return { ...state, tipo: action.payload };
    }
    case Types.SET_INFO_ENDERECO: {
      return { ...state, ...action.payload.endereco };
    }
    case Types.RESET:
      return { ...INITIAL_STATE, tipo: state.tipo };
    case Types.CHANGE_STEP:
      return { ...state, step: state.step + action.payload };
    case Types.SET_STEP:
      return { ...state, step: action.payload };
    case Types.FINISH_INDICACAO_SUCCESS:
      return { ...state, showModal: true };
    case Types.FINISH_INDICACAO_FAILURE:
      return { ...state, showModal: false };
    default:
      return state;
  }
}
